module.exports = __webpack_public_path__ + "img/297800_262280200481108_1070173634_n.928ea022.jpg";